export default {
  // Header
  header: {
    activities: 'Latest Activities',
    products: 'Products',
    solutions: 'Solutions',
    partners: 'Partners',
    aboutUs: 'About Us',
    login: 'Login',
    register: 'Free Register',
    search: 'Search products, docs...',
    registerBenefits: 'Register to get benefits:',
    benefit1: '30+ products free trial',
    benefit2: 'Exclusive offers for new users',
    benefit3: 'Early access to new products',
    signUpFree: 'Sign up for free'
  },
  
  // Search
  search: {
    quickAccess: 'Quick Access',
    hotProducts: 'Hot Products',
    hkServer: 'Hong Kong Server',
    cloudServer: 'Cloud Server',
    ddosProtection: 'DDoS Protection',
    sslCertificate: 'SSL Certificate',
    bgpServer: 'BGP Server',
    colocation: 'Colocation',
    multiIpServer: 'Multi-IP Server'
  },
  
  // Footer
  footer: {
    support247: '24/7',
    premiumSupport: 'Premium Support',
    newUser: 'New User',
    freeTrials: 'Free Trials',
    alwaysOn: 'Always On',
    expertGuidance: 'Expert Guidance',
    reliable: 'Reliable',
    uptime: '99.95% Uptime',
    
    companyIntro: 'Company Introduction',
    aboutUs: 'About Us',
    joinUs: 'Join Us',
    industryNews: 'Industry News',
    
    support: 'Support',
    contactSales: 'Contact Sales',
    openTicket: 'Open Ticket',
    tickets: 'Tickets',
    searchDownloads: 'Search Downloads',
    knowledgebase: 'Knowledgebase',
    announcements: 'Announcements',
    networkStatus: 'Network Status',
    
    billing: 'Billing',
    invoices: 'Invoices',
    quotes: 'Quotes',
    paymentMethod: 'Payment Method',
    addFunds: 'Add Funds',
    viewCart: 'View Cart',
    
    accountOverview: 'Account Overview',
    manageAccount: 'Manage Your Account',
    userManagement: 'User Management',
    accountSecurity: 'Account Security',
    
    hotline: '24/7 Hotline',
    companyName: 'Nebula Global LLC',
    companyAddress: '1359 S DREXEL WAY LAKEWOOD CO 80232 US',
    companyEmail: 'support@nebulaglobal.net',
    companyPhone: '+1(970)516-9999',
    companyDesc: 'SCGIDC: Premium cloud solutions. Vision: Building a trustworthy, cost-effective cloud brand.',
    
    copyright: 'Copyright © 2024-2026 Nebula Global LLC. All Rights Reserved.',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    acceptableUsePolicy: 'Acceptable Use Policy',
    dsaPolicy: 'DSA Policy',
    dmcaPolicy: 'DMCA Policy'
  },
  
  // Home
  home: {
    // Banner 1
    banner1Tag1: 'Ultra-Low Latency',
    banner1Tag2: 'Direct China-HK Link',
    banner1Title: 'Hong Kong Servers: Premium Deals',
    banner1MainDesc: 'Powerful Performance, Ultimate Network',
    banner1SubDesc: 'Site Clusters \u00b7 Premium IP | High-Bandwidth \u00b7 New Arrival',
    // Banner 2
    banner2Tag1: 'Mature Architecture',
    banner2Tag2: 'CN2 Direct Line',
    banner2Title: 'Japan Cloud Servers: Expanded',
    banner2MainDesc: 'Resource Pool Expanded \u00b7 New Experience',
    // Banner 3
    banner3Tag1: 'High Defense',
    banner3Tag2: 'Stress Testing Support',
    banner3Title: 'Hong Kong Anti-DDoS IP Upgraded',
    banner3MainDesc: 'High Defense \u00b7 Fast Integration',
    banner3SubDesc: '200G Real Defense, 3-Min Setup, Flexible Protection',
    // Slide tabs
    bannerTitle1: 'Hong Kong Servers',
    bannerDesc1: 'Ultra-Low Latency, Premium Deals',
    bannerTitle2: 'Japan Cloud',
    bannerDesc2: 'Resource Pool Expanded',
    bannerTitle3: 'Anti-DDoS IP',
    bannerDesc3: '200G Real Defense, Fast Setup',
    
    globalPartners: 'Global Top-Tier Network Partners',
    hotProducts: 'High-Speed No-ICP Products',
    hotProductsDesc: '14-yr expertise, 100k+ clients',
    featured: 'Featured',
    cloudServers: 'Cloud Servers',
    physicalServers: 'Physical Servers',
    antiDdos: 'Anti-DDoS',
    
    buyNow: 'Buy Now',
    details: 'Details',
    viewDetails: 'View Details',
    consultNow: 'Consult Now',
    productDetails: 'Product Details',
    console: 'Console',
    contactUs: 'Contact Us',
    contactSales: 'Contact Sales',
    
    expert1v1: '1v1 Expert',
    customSolutions: 'Custom Solutions',
    freeMigration: 'Free Migration Guide',
    insiderDeals: 'Insider Deals',
    expertSupport: 'Expert Support',
    customProtection: 'Custom Protection',
    alwaysAvailable: 'Always Available',
    budgetFriendly: 'Budget-Friendly',
    enterpriseGrade: 'Enterprise-Grade',
    instantSetup: 'Instant Setup',
    
    // Product cards
    cloudServer: 'Cloud Server',
    physicalServer: 'Physical Server',
    antiDdosServer: 'Anti-DDoS Server',
    antiDdosIp: 'Anti-DDoS IP',
    antiDdosCloud: 'Anti-DDoS Cloud',
    hkCloudServer: 'HK Cloud Server',
    jpCloudServer: 'Japan Cloud Server',
    usCloudServer: 'US Cloud Server',
    hkAntiDdosCloud: 'HK Anti-DDoS Cloud',
    hkCloudIntl: 'HK Cloud (Intl)',
    hkCloudOptimized: 'HK Cloud (Optimized)',
    hkServer: 'HK Server',
    jpServer: 'Japan Server',
    hkHighBwServer: 'HK High-BW Server',
    hkMultiIpServer: 'HK Multi-IP Server',
    usServer: 'US Server',
    krServer: 'Korea Server',
    hkAntiDdosServer: 'HK Anti-DDoS Server',
    hkAntiDdosIp: 'HK Anti-DDoS IP',
    usAntiDdos: 'US Anti-DDoS',
    
    // Product descriptions
    ddosProtection300G: '300G DDoS Protection',
    ddosDefense200G: '200G Defense in 3min',
    smartMitigation: 'Smart Mitigation',
    noIcpBestseller: 'No-ICP Bestseller',
    multiLineOptions: 'Multi-Line Options',
    latencyToChina: '60-120ms to China',
    cn2Gia: 'CN2 GIA',
    dedicatedBw: '120-180ms, Dedicated BW',
    payByTraffic: 'Pay-by-Traffic',
    ddosProtected: '300G DDoS Protected',
    globalBandwidth: 'Global Bandwidth',
    bw30MPlus: '30M+ BW',
    costEffective: 'Cost-Effective',
    bw10MPlus: '10M+ BW',
    clients100K: '100k+ Clients',
    freeIntranet: 'Free Intranet',
    fastChinaAccess: 'Fast China Access',
    standard20M: '20M Standard',
    optimizedBw300M: '300M Optimized BW',
    rapidDeployment: 'Rapid Deployment',
    bulkIpsAvailable: 'Bulk IPs Available',
    cn2Optional30M: '30M CN2 Optional',
    freeDefense10G: 'Free 10G Defense',
    premiumKtLgDc: 'Premium KT/LG DC',
    protection310G: '310G Protection',
    testBeforeBuy: 'Test Before Buy',
    upgraded: 'Upgraded',
    elasticDefense300G: '300G Elastic Defense',
    scaleOnDemand: 'Scale On-Demand',
    tier1Protection: 'Tier-1 Protection',
    protectedIps5: '5 Protected IPs',
    
    ddosExpertise14yr: '14-yr Defense Expertise',
    shopNow: 'Shop Now',
    
    solutionsTitle: 'Proven Scenario-Based Solutions',
    solutionsDesc: 'Professional solutions for diverse business scenarios, offering versatile choices',
    retail: 'Retail',
    retailDesc: 'Omni-channel marketing, member management, customer LTV. Drive retail digitalization.',
    automotive: 'Automotive',
    automotiveDesc: 'Personalized mobility, deeper user engagement. Accelerate OEM digital transformation.',
    finance: 'Finance',
    financeDesc: 'AUM growth, intelligent risk control, smart branches. Boost financial intelligence.',
    cultureTourism: 'Culture & Tourism',
    cultureTourismDesc: 'Online Ops boost growth, industry digitalization. Be the guide for gov, biz & tourists.',
    internetPlus: 'Internet+',
    internetPlusDesc: 'One-stop infra, data, media & AI. Fuel business growth.',
    contactSupport: 'Contact Support',
    
    announcements: 'Latest Announcements',
    announcementsDesc: 'Stay updated with our latest news',
    viewAll: 'View All',
    
    perMonth: '/month',
    perYear: '/year',
    startingFrom: 'from',
    
    // Features section
    featuresTitle: '14-Yr HK/Overseas Server Experts',
    featuresDesc: '14-yr expertise managing servers globally',
    
    feature1Title: '14-Yr IDC Veteran',
    feature1Desc: 'Enterprise ICT solutions: global colocation, networking, DR',
    feature1Link: 'About Us',
    
    feature2Title: 'Resource Diversity',
    feature2Desc: 'APNIC/ARIN member with ASN, ample IPv4/IPv6 resources',
    feature2Link: 'Contact Support',
    
    feature3Title: 'Global Low-Latency',
    feature3Desc: 'HK/US/JP/KR direct to CN2/CMI/Unicom with BGP redundancy',
    feature3Link: 'Test IPs',
    
    feature4Title: 'Tier\u2162+ Data Centers',
    feature4Desc: '2N redundancy, 99.982% uptime',
    feature4Link: 'Data Centers',
    
    feature5Title: 'No ICP Required',
    feature5Desc: 'Instant deployment: VMs to bare metal',
    feature5Link: 'Contact Support',
    
    feature6Title: '24/7 On-Site Support',
    feature6Desc: 'CCIE team in DCs, rapid incident response',
    feature6Link: 'Submit Ticket',
    
    feature7Title: 'Annual HW Refresh',
    feature7Desc: 'Prevent aging hardware issues',
    feature7Link: 'HW Customization',
    
    feature8Title: 'Data Privacy',
    feature8Desc: 'Full customer data ownership',
    feature8Link: 'Privacy Policy',
    
    feature9Title: '99.9% Uptime SLA',
    feature9Desc: 'Compensation guaranteed',
    feature9Link: 'SLA Details',
    
    feature10Title: '24/7 Premium Support',
    feature10Desc: 'Multi-channel assistance anytime',
    feature10Link: 'Custom Services',
    
    // Solutions section
    retail: 'Retail',
    retailDesc: 'Omni-channel marketing, member management, customer LTV. Drive retail digitalization.',
    automotive: 'Automotive',
    automotiveDesc: 'Personalized mobility, deeper user engagement. Accelerate OEM digital transformation.',
    finance: 'Finance',
    financeDesc: 'AUM growth, intelligent risk control, smart branches. Boost financial intelligence.',
    cultureTourism: 'Culture & Tourism',
    cultureTourismDesc: 'Online Ops boost growth, industry digitalization. Be the guide for gov, biz & tourists.',
    internetPlus: 'Internet+',
    internetPlusDesc: 'One-stop infra, data, media & AI. Fuel business growth.',
    contactSupport: 'Contact Support',
    
    // Region labels
    hkUsJp: 'HK/US/JP',
    hkUs: 'HK/US',
    hongKong: 'Hong Kong',
    
    // Tags
    tagHot: 'HOT',
    tagNew: 'NEW'
  },
  
  // Announcements
  announcements: {
    item1Title: 'Hong Kong Server Expansion Complete',
    item1Desc: 'New high-performance nodes now available with enhanced bandwidth capacity',
    item2Title: 'New Year Promotion: 30% Off',
    item2Desc: 'Limited time offer on all cloud servers and dedicated hosting plans',
    item3Title: 'DDoS Protection Upgraded to 300G',
    item3Desc: 'Enhanced protection capabilities with faster response times',
    item4Title: 'Japan Data Center Now Live',
    item4Desc: 'Ultra-low latency connections to Asia Pacific region',
    tagUpdate: 'Update',
    tagPromo: 'Promo',
    tagNew: 'New',
    tagLaunch: 'Launch'
  },
  
  // Products Menu
  products: {
    allProducts: 'All Products',
    physicalServer: 'Physical Server',
    cabinetRental: 'Cabinet Rental',
    cloudServer: 'Cloud Server',
    ddosProtection: 'DDOS Protection',
    crossBuildingLinks: 'Cross-Building Links',
    multiIpServers: 'Multi-IP Servers',
    sslCertificates: 'SSL Certificates',
    domains: 'Domains'
  },
  
  // Solutions Menu
  solutions: {
    service: 'Service',
    serviceDesc: 'Professional service solutions',
    colocation: 'Colocation',
    colocationDesc: 'Professional server colocation services',
    bandwidth: 'Bandwidth',
    bandwidthDesc: 'High-speed bandwidth solutions',
    ipTransit: 'IP Transit',
    ipTransitDesc: 'Enterprise-grade IP transit solutions with global coverage',
    crossCloud: 'Cross Cloud Connection',
    crossCloudDesc: 'Secure multi-cloud network connectivity',
    hybridCloud: 'Hybrid Cloud',
    hybridCloudDesc: 'Seamless integration of public and private clouds',
    dcInterconnect: 'Data Center Interconnect',
    dcInterconnectDesc: 'High-performance data center interconnection'
  },
  
  // Partners Menu
  partners: {
    partners: 'Partners',
    partnerWithUs: 'Partner with us',
    joinProgram: 'Join our partner program',
    affiliateProgram: 'Affiliate Program',
    affiliateDesc: 'Earn 15% commission! $50 bonus'
  },
  
  // About Menu (Header dropdown)
  aboutMenu: {
    infrastructure: 'Infrastructure',
    expertise: '10+ years HK/overseas expertise',
    companyIntro: 'Company Introduction',
    history: 'History',
    joinUs: 'Join Us',
    contactUs: 'Contact Us'
  },
  
  // Server Products
  serverProducts: {
    hkBgpPremium: 'HK BGP Premium',
    hkBgpStandard: 'HK BGP Standard',
    hkBgpGlobal: 'HK BGP Global',
    hkBgpAntiDdos: 'HK BGP Anti-DDoS',
    hkBgpPremiumDesc: 'Direct connect to global ISP routes, including Mainland China',
    cloud: 'Cloud',
    antiDdos: 'AntiDDoS',
    hkColocation: 'HK Server Colocation',
    crossBuilding: 'Cross-Building Links',
    siteCluster: 'Site Cluster Server',
    ssl: 'SSL Certificate'
  },
  
  // Common
  common: {
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    month: '/month',
    year: '/year',
    hot: 'HOT',
    new: 'NEW',
    viewDetails: 'View Details',
    shopNow: 'Shop Now'
  },

  // About Page
  about: {
    aboutUs: 'About Us',
    companyName: 'Nebula Global LLC',
    companySlogan: 'Global DC provider, APNIC/ARIN member with ASN, IPv4/IPv6 resources',
    clientArea: 'Client Area',
    companyIntro: 'Company Introduction',
    joinUs: 'Join Us',
    companyDesc: 'SCGIDC: Enterprise cloud solutions for developers, governments, financial institutions.',
    visionMission: 'Vision & Mission',
    vision: 'Vision',
    visionText: 'Build a better digital society',
    mission: 'Mission',
    missionText: 'Make the world more efficient',
    globalOffices: 'Global Offices',
    singapore: 'Singapore',
    hongKong: 'Hong Kong',
    losAngeles: 'Los Angeles',
    korea: 'Korea',
    whyChooseUs: 'Why Choose Us',
    feature1Title: 'Security & Reliability',
    feature1Desc: 'Multi-layer security and 99.95% SLA guarantee',
    feature2Title: 'Global Network',
    feature2Desc: 'Premium connectivity across major regions',
    feature3Title: '24/7 Support',
    feature3Desc: 'Round-the-clock expert technical support',
    followUs: 'Follow Us',
    socialDesc: 'Stay connected with us on social media for the latest news and updates'
  },
    
  // Data Center Page
  datacenter: {
    title: 'Data Centers',
    globalDataCenters: 'Global Data Centers',
    subtitle: 'Premium enterprise-grade infrastructure with 99.99% uptime SLA',
    explore: 'Explore Data Centers',
    learnMore: 'Learn More',
    features: 'Features',
    specs: 'Specifications',
    certifications: 'Certifications',
    location: 'Location',
    tier: 'Tier Rating',
    power: 'Power Infrastructure',
    cooling: 'Cooling Systems',
    connectivity: 'Connectivity',
    security: 'Security',
    back: 'Back to List',
    select: 'Select Data Center',
    overview: 'Overview',
    network: 'Network',
    securityCompliance: 'Security & Compliance',
    allDataCenters: 'All Data Centers',
    backToList: 'Back to List',
    viewProducts: 'View Products',
    specifications: 'Specifications',
    infrastructure: 'Infrastructure',
    ourLocations: 'Our Locations',
    locationsDesc: 'Click on a location to learn more about our data center facilities',
    clientArea: 'Client Area',
    // Data center details
    centers: {
      'mega-i': {
        name: 'MEGA-i Hong Kong Data Center',
        region: 'Hong Kong',
        location: 'Chai Wan, Hong Kong',
        subtitle: "Asia's Premier Interconnection Hub · Most Carrier-Dense Facility",
        advantageTitle: 'MEGA-i Competitive Advantages',
        infrastructureTitle: 'Military-Grade Infrastructure',
        notices: [
          { title: 'Tier III+ Certified Facility', desc: '99.982% availability with dual power + 24-hour backup' },
          { title: 'Asian Network Hub', desc: 'Direct access to 9 submarine cables and 300+ carriers' },
          { title: 'Carrier-Neutral Environment', desc: 'Flexible carrier selection with AWS/Azure cloud on-ramps' }
        ],
        descriptions: [
          "Flagship 350,000 sq ft facility at 399 Chai Wan Road - Asia's network interconnection core",
          'Connects 9/11 Hong Kong submarine cables: <45ms to Tokyo, <15ms to Singapore, <110ms to LA',
          'HKCA "Innovative Data Center Service" awardee and LEED Gold certified (PUE≤1.5)'
        ],
        infrastructure: [
          { title: 'Power System', items: ['Dual 11kV power sources (2000kVA transformers)', 'N+1 redundant UPS (400kVA/floor) with 30-min batteries', '2000kVA Diesel Generator (24/7 Continuous Power)'] },
          { title: 'Cooling System', items: ['Precision cooling: 20℃±2℃, 50%±10% humidity', 'Chiller units + direct expansion dual systems', 'Hot Aisle Containment Technology, PUE≤1.5'] },
          { title: 'Fire Protection', items: ['VESDA aspirating smoke detection', 'FM200 Clean Agent Fire Suppression System'] },
          { title: 'Network Architecture', items: ['15,000+ cross-connections for high-speed interconnects', '100mm steel conduits protecting fiber backbone'] },
          { title: 'Security System', items: ['Dual-door interlock + biometric access control', 'Infrared Thermal Imaging Surveillance + Armed Guard Patrols'] },
          { title: 'Operations Support', items: ['24/7 on-site engineering support', '15-Minute Fault Response SLA Guarantee'] }
        ]
      },
      'chief': {
        name: 'Chief Telecom Li-Yuan Data Center',
        region: 'Hong Kong',
        location: 'Kwai Chung, Hong Kong',
        subtitle: 'Asian Cable Hub · 90% Trans-Pacific Traffic Node',
        advantageTitle: 'East Asia Digital Hub',
        infrastructureTitle: 'Military-Grade Infrastructure',
        notices: [
          { title: 'Tier III+ Certified Facility', desc: '99.982% uptime with dual 11kV feeds + 72-hour backup' },
          { title: 'Asian Submarine Cable Hub', desc: 'Direct access to 9 cables carrying 90% Asian trans-Pacific traffic' },
          { title: 'Carrier-Neutral Environment', desc: '200+ carriers with multi-path BGP routing' }
        ],
        descriptions: [
          '6-story purpose-built IDC facility at Yangguang St, Taipei (10,000+ sq m)',
          'Connected to TPIX/TPVX/TPCX exchanges: <15ms to Tokyo, <35ms to Singapore',
          'Chunghwa Telecom subsidiary (ISO 27001/9001) supporting AWS/Azure direct connect'
        ],
        infrastructure: [
          { title: 'Power System', items: ['2N redundant UPS (18,000KVA total)', 'Dual 11kV feeds + diesel backup (72-hour)'] },
          { title: 'Cooling System', items: ['N+1 redundant chillers (22±2℃)', 'Hot aisle containment (PUE≤1.5)'] },
          { title: 'Fire Protection', items: ['VESDA + FM200 suppression'] },
          { title: 'Network Architecture', items: ['BGP intelligent routing (CT/CU/CM/EDU)', '15,000+ cross-connections with 100Gbps interconnect'] },
          { title: 'Physical Security', items: ['Biometrics + thermal imaging with anti-tailgating'] },
          { title: 'Operations', items: ['24/7 on-site engineers with 15-minute response SLA'] }
        ]
      },
      'globalswitch': {
        name: 'Global Switch Hong Kong',
        region: 'Hong Kong',
        location: 'Tseung Kwan O, Hong Kong',
        subtitle: 'World-Class Carrier-Neutral Facility · Green Energy Certified',
        advantageTitle: 'Global Switch Advantages',
        infrastructureTitle: 'Military-Grade Infrastructure',
        notices: [
          { title: 'World-Class Infrastructure', desc: 'Purpose-built facility with 2N+1 redundancy' },
          { title: 'Green Energy Certified', desc: 'LEED Certified with industry-leading PUE' },
          { title: '100+ Carriers Connected', desc: 'Extensive ecosystem of network providers' }
        ],
        descriptions: [
          'Premium data center campus in Tseung Kwan O Industrial Estate',
          'Multi-tier security with 24/7 on-site personnel',
          'Direct connectivity to major cloud providers and carriers'
        ],
        infrastructure: [
          { title: 'Power System', items: ['2N+1 redundant power architecture', 'Multiple utility feeds with diesel backup'] },
          { title: 'Cooling System', items: ['Hot/Cold aisle containment', 'Energy-efficient cooling systems'] },
          { title: 'Fire Protection', items: ['VESDA early warning detection', 'Gas-based suppression system'] },
          { title: 'Network', items: ['100+ carrier options', 'Direct cloud on-ramps'] },
          { title: 'Security', items: ['Multi-layer physical security', 'Biometric access control'] },
          { title: 'Operations', items: ['24/7 NOC support', 'Remote hands service'] }
        ]
      },
      'eq-sg1': {
        name: 'Equinix SG1 Singapore',
        region: 'Singapore',
        location: 'Singapore',
        subtitle: 'Southeast Asia Gateway · Premium IBX Data Center',
        advantageTitle: 'Equinix Singapore Advantages',
        infrastructureTitle: 'Enterprise Infrastructure',
        notices: [
          { title: 'IBX Premium Facility', desc: 'Industry-leading interconnection platform' },
          { title: 'Direct Cloud Connect', desc: 'AWS, Azure, Google Cloud direct access' },
          { title: 'Rich Ecosystem', desc: '500+ networks and 2,000+ enterprises' }
        ],
        descriptions: [
          'Strategic location in Southeast Asia financial hub',
          'Equinix Fabric for software-defined interconnection',
          'Comprehensive compliance certifications'
        ],
        infrastructure: [
          { title: 'Power System', items: ['2N UPS + diesel generators', 'SLA-backed uptime guarantee'] },
          { title: 'Cooling System', items: ['Chilled water cooling', 'N+1 redundancy'] },
          { title: 'Fire Protection', items: ['VESDA detection', 'Clean agent suppression'] },
          { title: 'Network', items: ['Equinix Fabric', '500+ network providers'] },
          { title: 'Security', items: ['Mantrap entry', 'Biometric + card access'] },
          { title: 'Operations', items: ['24/7 Smart Hands', 'Global NOC support'] }
        ]
      },
      'eq-ty8': {
        name: 'Equinix TY8 Tokyo',
        region: 'Japan',
        location: 'Tokyo, Japan',
        subtitle: 'Asia Pacific Financial Hub · Ultra-Low Latency',
        advantageTitle: 'Equinix Tokyo Advantages',
        infrastructureTitle: 'Enterprise Infrastructure',
        notices: [
          { title: 'Financial Hub Location', desc: 'Direct access to Tokyo Stock Exchange ecosystem' },
          { title: 'Ultra-Low Latency', desc: 'Optimized for high-frequency trading' },
          { title: 'Disaster Recovery', desc: 'Seismic isolation and backup power' }
        ],
        descriptions: [
          'Purpose-built for financial services and enterprise',
          'Connected to major Japanese carriers and IX',
          'Robust disaster preparedness infrastructure'
        ],
        infrastructure: [
          { title: 'Power System', items: ['2N concurrent maintainable', '72-hour fuel supply'] },
          { title: 'Cooling System', items: ['N+1 CRAC units', 'Hot/cold aisle containment'] },
          { title: 'Fire Protection', items: ['VESDA + FM200'] },
          { title: 'Network', items: ['200+ network providers', 'JPIX/JPNAP connected'] },
          { title: 'Security', items: ['24/7 security personnel', 'Multi-factor authentication'] },
          { title: 'Operations', items: ['Bilingual support', 'On-site engineering'] }
        ]
      },
      'coresite-la1': {
        name: 'CoreSite LA1 Data Center',
        region: 'USA',
        location: 'Los Angeles, CA',
        subtitle: 'West Coast connectivity hub with direct Asia-Pacific submarine cable access',
        advantageTitle: 'CoreSite LA1 Strategic Advantages',
        infrastructureTitle: 'Core Infrastructure',
        notices: [
          { title: 'Industry Certification', desc: 'ISO 27001 certified with 24/7 engineering support' },
          { title: 'Stable Power Supply', desc: 'N+1 redundant UPS design ensures reliability' },
          { title: 'Liquid-Cooled Facility', desc: 'Condensation cooling for enhanced efficiency' }
        ],
        descriptions: [
          "Located at One Wilshire - West Coast's most critical network exchange hub",
          'Over 173,000 sq ft facility with cutting-edge infrastructure',
          'Ideal for high-density, compute-intensive deployments'
        ],
        infrastructure: [
          { title: 'Power System', items: ['N+1 redundant UPS', 'Backup diesel generators (72-hour)', 'Diversified power sources'] },
          { title: 'Cooling System', items: ['N+1 cooling towers and chillers', 'Condensation cooling', 'RFID environmental monitoring'] },
          { title: 'Fire Protection', items: ['VESDA early smoke detection', 'Dual interlock pre-action sprinklers'] },
          { title: 'Network Architecture', items: ['Hundreds of carriers with dark fiber', 'AWS Direct Connect/Azure ExpressRoute'] },
          { title: 'Security System', items: ['Biometric access + 24/7 security personnel'] },
          { title: 'Technical Support', items: ['24/7 operations with 100% SLA uptime guarantee'] }
        ]
      },
      'west7': {
        name: 'West 7 Los Angeles Underground Facility',
        region: 'USA',
        location: 'Los Angeles, CA',
        subtitle: "World's Largest Underground Data Hub · Trans-Pacific Gateway",
        advantageTitle: 'West Coast Digital Fortress',
        infrastructureTitle: 'Core Infrastructure',
        notices: [
          { title: 'Tier III+ Underground Fortress', desc: '172,000 sq ft with 99.995% availability' },
          { title: '17MW Power Redundancy', desc: 'Dual grids + 3000kVA UPS with 72-hour backup' },
          { title: 'Strategic Network Hub', desc: 'Direct access to 6 trans-Pacific cables' }
        ],
        descriptions: [
          'Deep bedrock location: seismic 9-rating, 7m flood protection',
          'Terminal for TPE/EAC-C2C cables: <85ms to Tokyo, <120ms to Shanghai',
          'ISO 27001/SSAE 18 certified with 30Pa positive pressure containment'
        ],
        infrastructure: [
          { title: 'Power System', items: ['2N UPS (3000kVA) + 18×2MVA transformers', 'Dual 138kV feeders with 72-hour generators'] },
          { title: 'Cooling System', items: ['9,000-ton water cooling (PUE≤1.35)', 'Geothermal bedrock cooling (±0.5℃ stability)'] },
          { title: 'Fire Protection', items: ['VESDA laser detection + fluoroketone suppression'] },
          { title: 'Network Architecture', items: ['12 tier-1 carriers including AT&T/Verizon', '100Gbps backbone with BGP optimization'] },
          { title: 'Physical Security', items: ['Military-grade biometrics + anti-tailgating airlock', 'Bulletproof glass monitoring + dynamic pressure sensors'] },
          { title: 'Operations', items: ['24/7 engineers with 5-minute emergency SLA', '4-hour hardware failure replacement'] }
        ]
      },
      'tyo1': {
        name: 'DigitalEdge TYO1 Tokyo Data Center',
        region: 'Japan',
        location: 'Bunkyo, Tokyo',
        subtitle: 'Bunkyo Core · Tier III Certified · 3.76MW High-Density Hub',
        advantageTitle: 'Heart of Tokyo Digital Hub',
        infrastructureTitle: 'Core Facility Specifications',
        notices: [
          { title: 'Finance-Grade Low Latency', desc: 'Connected to 8 major exchanges; HFT latency <0.5ms' },
          { title: 'Fully Redundant Infrastructure', desc: 'N+1 UPS + Triple Feeds; 24-hour gas turbine backup' },
          { title: 'Prime Tokyo Location', desc: '5 min to Yamanote Line; adjacent to Telecom Hub' }
        ],
        descriptions: [
          '2,470㎡ colocation space with 940 cabinets; Triple ISO certified',
          'Cross Link™ seamless low-latency connections to TYO2/TYO3',
          'FSA-designated compliant for HFT and edge computing'
        ],
        infrastructure: [
          { title: 'Power System', items: ['Triple utility feeds', 'N+1 Parallel Redundant UPS', '3×4,000kVA gas turbines (24-hour reserve)'] },
          { title: 'Cooling System', items: ['N+1 Underfloor Air Conditioning', 'PUE 1.5 Tokyo Low-Carbon Compliance', '4kVA power density per cabinet'] },
          { title: 'Fire Protection', items: ['VESDA Aspirating Detection', 'Inert Gas Suppression'] },
          { title: 'Network Architecture', items: ['3 separate fiber entry routes', 'Cross Connect & Cross Link™ Interconnection'] },
          { title: 'Physical Security', items: ['Biometric + Anti-Tailgating + 24/7 SOC', 'Exceeds Japanese Building Standards seismic requirements'] },
          { title: 'Operations', items: ['24/365 Remote Hands', '100% Dual-circuit / 99.99% Single-circuit SLA'] }
        ]
      },
      'tgt': {
        name: 'TGT Hong Kong Data Center',
        region: 'Hong Kong',
        location: 'Tseung Kwan O, Hong Kong',
        subtitle: 'Tseung Kwan O Core Hub · Strategic Submarine Cable Node',
        advantageTitle: "Asia's Core Digital Hub",
        infrastructureTitle: 'Military-Grade Infrastructure',
        notices: [
          { title: 'TIA-942 Rated 3+ Certified', desc: '99.982% uptime with dual power + 72-hour backup' },
          { title: 'Direct Submarine Cable Access', desc: '<5ms latency to major Asian cities' },
          { title: 'Gas Pipeline Fiber Technology', desc: 'GIG technology reduces failures 60%; seismic resistant' }
        ],
        descriptions: [
          "22 Chun Cheong St - Asia's government-planned data center hub",
          '5-story, 22,000 sq m facility supporting 3,300 high-density racks',
          'Advanced secured infrastructure for cross-border business'
        ],
        infrastructure: [
          { title: 'Power System', items: ['18,000KVA with 2N redundant UPS + 24×2MVA transformers', 'Dual 11kV feeds + diesel backup (72-hour)'] },
          { title: 'Cooling System', items: ['Water-cooled + lithium bromide absorption (PUE≤1.5)', 'Hot aisle containment ±0.5℃ stability'] },
          { title: 'Fire Protection', items: ['VESDA + FM200 clean agent suppression'] },
          { title: 'Network Architecture', items: ['7 tier-1 providers including PCCW/HKBN', 'Dual POP with BGP multi-path switching'] },
          { title: 'Physical Security', items: ['Biometric + thermal imaging (ISO27001/9001)'] },
          { title: 'Operations', items: ['24/7 engineers with 15-minute response SLA'] }
        ]
      },
      'global-switch-woolands': {
        name: 'Global Switch Woodlands Facility',
        region: 'Singapore',
        location: 'Woodlands, Singapore',
        subtitle: 'APAC Green Digital Hub · 30MW Active-Active Design',
        advantageTitle: 'Southeast Asia Digital Hub',
        infrastructureTitle: 'Core Infrastructure',
        notices: [
          { title: 'Tier III+ Certified Facility', desc: '99.982% uptime with dual substations + 24-hour backup' },
          { title: 'Singapore Efficiency Benchmark', desc: 'PUE 1.34 with LEED Gold + BCA Platinum' },
          { title: 'Financial-Grade Security', desc: 'MAS compliance with crash barriers + biometrics' }
        ],
        descriptions: [
          '7-story Woodlands facility (25,000 sq m), 7,800 rack capacity',
          '<1ms fiber to Tai Seng facility with 300+ carriers',
          'Modular prefabrication (60% MEP factory-built)'
        ],
        infrastructure: [
          { title: 'Power System', items: ['Dual substation feeds (30MVA)', '18 rooftop DRUPS (N+2)', '200,000L fuel storage (24/7 power)'] },
          { title: 'Cooling System', items: ['Variable frequency fans + efficient CRAH', '3.5m clear height for 58U cabinets', 'Reconfigurable power distribution'] },
          { title: 'Fire Protection', items: ['VESDA aspirating detection', 'FM200 clean agent suppression'] },
          { title: 'Network Architecture', items: ['Dual fiber to MMR exchange rooms', '5-ton dedicated freight elevator'] },
          { title: 'Physical Security', items: ['Crash-rated barriers + perimeter detection', 'Roof-mounted generator protection'] },
          { title: 'Operations', items: ['24/7 engineering support', 'Zero-downtime migration service'] }
        ]
      }
    }
  },
  
  contact: {
    contactUs: 'Contact Us',
    contactDesc: 'We want to hear from you.<br>For inquiries, feedback, or partnerships, please contact us.',
    openTicket: 'Open Ticket',
    phoneSupport: 'Phone Support',
    phoneDesc: '24/7 available for VIP solutions',
    callNow: 'Call Now',
    supportTicket: 'Support Ticket',
    email: 'Email',
    preSalesAfterSales: 'Pre-Sales & After-Sales',
    channelTitle: 'Answers to common questions to help you get started',
    liveChat: 'Live Chat',
    liveChatDesc: 'Real-time chat for instant answers',
    hours: 'Hours',
    phoneSupportDesc: 'Fast response, 24/7 available',
    ticketDesc: 'Submit a ticket, we will respond ASAP',
    priority: 'Priority',
    documentation: 'Documentation',
    docDesc: 'View FAQs and tutorials',
    selfService: 'Self-Service',
    ourOffices: 'Our Offices',
    officeWelcome: 'Welcome to visit us, we are here to serve you',
    usHeadquarters: 'US Headquarters',
    hongKongOffice: 'Hong Kong',
    announcements: 'Announcements',
    networkStatus: 'Network Status',
    myTickets: 'My Tickets'
  },

  // Legal Pages
  legal: {
    legal: 'Legal',
    tableOfContents: 'Table of Contents',
    otherPolicies: 'Other Policies',
    lastUpdated: 'Last Updated',
    contactInfo: 'For questions about these terms, please contact support@nebulaglobal.net',
    tosDesc: 'Please read these terms and conditions carefully before using our services',
    privacyDesc: 'Learn how we collect, use, and protect your personal information',
    aupDesc: 'Guidelines for acceptable use of our services',
    dsaDesc: 'Digital Services Act compliance information',
    dmcaDesc: 'Our policy regarding copyright infringement claims',
    tos: {
      section1Title: 'Use Of Products And Services',
      section1Content1: 'You may use any of our services, provided that you are of legal age to form a binding contract and are not a person barred from receiving services under the laws of the country the service resides in.',
      section1Content2: 'We may cancel or suspend your access to our services at any time and for any reason without notice.',
      section2Title: 'Conditions Of Use',
      section2Content1: 'You agree that any violations listed in our Acceptable Use Policy are considered prohibited usage and may result in immediate account suspension and/or termination without compensation.',
      section2Content2: 'Intentional or malicious violations of our Acceptable Use Policy will result in immediate termination and a ban from any further service.',
      section3Title: 'Account Registration',
      section3Sub1: 'Contact Information',
      section3Item1: 'Clients must provide their legitimate name and surname and residential address when registering an account.',
      section3Item2: 'P.O. Boxes and non-residential or mail forwarding addresses are not accepted.',
      section3Item3: 'A valid phone number is recommended but not required for registration.',
      section3Item4: 'Account details must match information provided by payment method.',
      section3Sub2: 'Restrictions',
      section3Item5: 'Clients may not open multiple personal accounts under any circumstance.',
      section3Item6: 'Clients may not give other persons access to their accounts.',
      section3Item7: 'Clients may not change the name on their account to another individual.',
      section4Title: 'Billing',
      section4Sub1: 'Invoicing',
      section4Item1: 'Invoices for recurring services will be issued ten (10) days in advance of the due date.',
      section4Item2: 'Unpaid services will be suspended four (4) days past the due date on the service.',
      section4Item3: 'Unpaid services will be terminated twenty-one (21) days past the due date on the service.',
      section4Sub2: 'Account Credit',
      section4Item4: 'Account credit does not expire and cannot be transferred from one client to another.',
      section4Item5: 'Existing account credit will automatically be applied towards further generated invoices until exhausted.',
      section4Item6: 'Account credit may not be withdrawn or cashed out in the form of a refund or other payment.',
      section5Title: 'Payments & Gateways',
      section5Item1: 'PayPal transactions are eligible for refund within 3 days of the initial order payment.',
      section5Item2: 'PayPal payments must originate from a verified PayPal account.',
      section5Sub1: 'Credit/Debit Cards',
      section5Item3: 'Credit Card transactions are eligible for refund within 3 days of the initial order payment.',
      section5Sub2: 'Cryptocurrency',
      section5Item4: 'Bitcoin, Monero, Litecoin, DASH, and DOGE cryptocurrency payments are accepted.',
      section5Item5: 'Cryptocurrency payments are not eligible for refunds.',
      section6Title: 'Service Processing',
      section6Sub1: 'Service Provisioning',
      section6Item1: 'Orders are provisioned during business hours provided that contact information and payment are in accordance with the Terms of Service.',
      section6Item2: 'Orders placed outside business hours are provisioned within 24 hours.',
      section6Item3: 'Orders that remain unpaid for more than 24 hours are automatically removed from the system.',
      section6Sub2: 'Service Cancellation',
      section6Item4: 'Immediate cancellations are processed automatically the following morning.',
      section6Item5: 'Once cancelled, all related data and backups are destroyed. This cannot be reversed.',
      section7Title: 'Miscellaneous',
      section7Sub1: 'Business Hours',
      section7Item1: 'Support is provided 24 hours during weekdays. Weekend tickets are typically addressed within two hours.',
      section7Item2: 'Billing department hours are standard business hours on weekdays. Prompt replies are not guaranteed after hours.'
    },
    privacy: {
      section1Title: 'Information Collection',
      section1Content: 'We collect information you provide directly to us, including name, email address, payment information, and any other information you choose to provide.',
      section2Title: 'Information We Collect',
      section2Item1: 'Account registration information (name, email, address)',
      section2Item2: 'Payment and billing information',
      section2Item3: 'Technical data (IP addresses, browser type, device information)',
      section2Item4: 'Usage data and service interaction logs',
      section3Title: 'How We Use Information',
      section3Item1: 'Provide, maintain, and improve our services',
      section3Item2: 'Process transactions and send related information',
      section3Item3: 'Send technical notices, updates, and security alerts',
      section4Title: 'Information Sharing',
      section4Content: 'We do not sell, trade, or otherwise transfer your personal information to outside parties without your consent, except as required by law.',
      section5Title: 'Data Security',
      section5Content: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.',
      section6Title: 'Your Rights',
      section6Content: 'You have the right to access, correct, or delete your personal information. Contact us to exercise these rights.'
    },
    aup: {
      section1Title: 'Overview',
      section1Content: 'This Acceptable Use Policy outlines the acceptable and prohibited uses of our services to ensure a safe and reliable experience for all users.',
      section2Title: 'Prohibited Activities',
      section2Item1: 'Illegal activities or content that violates any applicable laws',
      section2Item2: 'Distribution of malware, viruses, or harmful code',
      section2Item3: 'Unauthorized access to systems or networks',
      section2Item4: 'Spam, phishing, or unsolicited communications',
      section2Item5: 'Content that infringes on intellectual property rights',
      section3Title: 'Network Abuse',
      section3Content: 'Any activity that disrupts or interferes with our network or other users is strictly prohibited. This includes DDoS attacks, port scanning, and excessive resource consumption.',
      section4Title: 'Enforcement',
      section4Content: 'Violations of this policy may result in immediate suspension or termination of services without refund. We reserve the right to take appropriate legal action.'
    },
    dsa: {
      section1Title: 'Digital Services Act Compliance',
      section1Content: 'In compliance with the EU Digital Services Act, we are committed to providing a transparent and safe online environment for all users.',
      section2Title: 'Content Moderation',
      section2Content: 'We employ both automated and human review processes to identify and address illegal content and policy violations.',
      section3Title: 'Reporting Mechanism',
      section3Content: 'Users can report illegal content or policy violations through our support ticket system. All reports are reviewed within 24-48 hours.'
    },
    dmca: {
      section1Title: 'DMCA Policy Overview',
      section1Content: 'We respect the intellectual property rights of others and expect our users to do the same. This policy outlines our procedures for handling copyright infringement claims.',
      section2Title: 'Filing a DMCA Notice',
      section2Item1: 'Identification of the copyrighted work claimed to be infringed',
      section2Item2: 'Identification of the material that is claimed to be infringing',
      section2Item3: 'Your contact information (name, address, phone, email)',
      section2Item4: 'A statement of good faith belief that the use is not authorized',
      section2Item5: 'A statement of accuracy and authority to act on behalf of the owner',
      section3Title: 'Counter-Notification',
      section3Content: 'If you believe your content was removed in error, you may submit a counter-notification with appropriate documentation.',
      section4Title: 'Contact Information',
      section4Content: 'DMCA notices should be sent to our designated agent at dmca@nebulaglobal.net'
    }
  },
  
  // Pages
  pages: {
    activity: {
      title: 'Latest Activities',
      subtitle: 'Check out current promotions and offers',
      metaDesc: 'Latest promotions, exclusive offers for new users'
    },
    products: {
      title: 'Products & Services',
      subtitle: 'View all our products',
      metaDesc: 'We offer cloud servers, physical servers, SSL certificates, domain registration and more'
    },
    solutions: {
      title: 'Solutions',
      subtitle: 'Professional enterprise-grade solutions',
      metaDesc: 'Hybrid cloud, cross-cloud connectivity, bandwidth services and other enterprise solutions'
    },
    docs: {
      title: 'Documentation',
      subtitle: 'Product documentation and tutorials',
      metaDesc: 'Product documentation, API documentation and usage tutorials'
    },
    news: {
      title: 'News & Announcements',
      subtitle: 'Latest news and announcements',
      metaDesc: 'Latest news, announcements and industry updates'
    },
    cloud: {
      title: 'Cloud Servers',
      subtitle: 'Elastic and scalable cloud computing solutions',
      metaDesc: 'Cloud servers with elastic scaling, pay-as-you-go, and fast deployment'
    },
    server: {
      title: 'Dedicated Servers',
      subtitle: 'High-performance dedicated server solutions',
      metaDesc: 'High-performance dedicated servers with exclusive resources'
    },
    ssl: {
      title: 'SSL Certificates',
      subtitle: 'Protect your website security',
      metaDesc: 'SSL certificates with fast issuance to protect your website'
    },
    domain: {
      title: 'Domain Registration',
      subtitle: 'Register your domain quickly',
      metaDesc: 'Domain registration with multiple TLD options at competitive prices'
    }
  }
}
